import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError, map, take, tap } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { User } from '../../shared/models/user.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private user: User;

  constructor(private http: HttpClient) {}

  /**
   * Descricao: realiza o cadastro
   * @param data 
   */
  public register(data: any) {
    return this.http.post(`${environment.api}/users/register/account`, data)
    .pipe(
      take(1),
      map((data: any) => data ),
      catchError(this.handleError)
    );
  }
  
  /**
   * Descricao: Obtem os dados do aluno
   * @param idAluno 
   * @param idTipoAcesso 
   * @param email 
   */
  public getStudent(idAluno: number) {   
    return this.http.get<any>(`${environment.api}/students/${idAluno}`,)
    .pipe(
      map((result: any) => {
        this.user = result.data;

        return this.user;
      }),
      catchError(this.handleError)
    );
  }

  /**
   * Descricao: Retorna os dados do usuário
   */
  public getDataStudent(): User {
    return this.user;
  }

  public clearDataStudent(): void {
    this.user = null;
  }
  
  public update(data: any) {
    return this.http.put<any>(`${environment.api}/users/account`, data)
    .pipe(      
      map((result: any) => result.data),
      catchError(this.handleError)
    );
  }
    
  /**
   * Description: Retorna lista de professores ordenados aleatoriamente e 3 por exibiçao
   */
  public getAllTeacherToCarousel() {    
    return this.http.get<any[]>(`${environment.api}/teachers/carousel`)
    .pipe(      
      take(1),     
      catchError(this.handleError)
    );
  }
  
  private handleError(error: any): Observable<any> {
    //console.log("ERRO NA REQUISIÇÃO =>", error);
    return throwError(error);
  }


}
